// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDeep = (object: any, path: string) => {
  return path.split(".").reduce((acc, key) => acc && acc[key], object);
};

export const deepClone = <T>(object: T): T =>
  JSON.parse(JSON.stringify(object));
